module.exports = "<edoc-transaction-list (onEdocEvent)=\"onEdocEventHandler($event)\"\n                       [attachments]=\"stepTransactionManager.attachments\"\n                       [optionList]=\"step.edocOptions\"\n                       [style]=\"cardStyle\"\n                       [task]=\"task\"\n                       [transactions]=\"stepTransactionManager.transactions\">\n</edoc-transaction-list>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/step-signature-edoc/step-signature-edoc.component.html
// module id = hY6j
// module chunks = 1